import styled from '@emotion/styled'

const StyledImg = styled.img`
  width: 40%;
  margin-bottom: 24px;
`

interface Props {
  alt: string
  fileName: string
}

export const PublicImg = ({ alt, fileName }: Props) => {
  return (
    <StyledImg
      alt={alt}
      src={`https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/${fileName}`}
    />
  )
}
